export enum Permission {
  DASHBOARD = 'DASHBOARD',
  REPORT = 'REPORT',

  LIST_USER = 'LIST_USER',
  CREATE_USER = 'CREATE_USER',
  UPDATE_USER = 'UPDATE_USER',

  LIST_USER_PROFILE = 'LIST_USER_PROFILE',
  CREATE_USER_PROFILE = 'CREATE_USER_PROFILE',
  UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE',

  LIST_MICHELIN_STOCK = 'LIST_MICHELIN_STOCK',
  CREATE_MICHELIN_STOCK = 'CREATE_MICHELIN_STOCK',
  UPDATE_MICHELIN_STOCK = 'UPDATE_MICHELIN_STOCK',

  LIST_DEALERSHIP = 'LIST_DEALERSHIP',
  CREATE_DEALERSHIP = 'CREATE_DEALERSHIP',
  UPDATE_DEALERSHIP = 'UPDATE_DEALERSHIP',

  LIST_ORDER = 'LIST_ORDER',
  UPDATE_ORDER = 'UPDATE_ORDER',

  LIST_AUTOMAKER = 'LIST_AUTOMAKER',
  CREATE_AUTOMAKER = 'CREATE_AUTOMAKER',
  UPDATE_AUTOMAKER = 'UPDATE_AUTOMAKER',
  CREATE_AUTOMAKER_ORDER = 'CREATE_AUTOMAKER_ORDER',
  LIST_AUTOMAKER_PRICE = 'LIST_AUTOMAKER_PRICE',
  UPDATE_AUTOMAKER_PRICE = 'UPDATE_AUTOMAKER_PRICE',

  LIST_DISTRIBUTOR = 'LIST_DISTRIBUTOR',
  CREATE_DISTRIBUTOR = 'CREATE_DISTRIBUTOR',
  UPDATE_DISTRIBUTOR = 'UPDATE_DISTRIBUTOR',
  LIST_DISTRIBUTOR_STOCK = 'LIST_DISTRIBUTOR_STOCK',
  UPDATE_DISTRIBUTOR_STOCK = 'UPDATE_DISTRIBUTOR_STOCK'
}
